import { BaseRequest } from "../../../../base/request/BaseRequest";

/** Request del paso 2: canjea el código OTP recibido por email por un
 *  `resetToken` de vida corta. Reenviar el mismo código correcto es seguro —
 *  el servidor devuelve el mismo token. */
export type VerificarCodigoRequest = BaseRequest & {
  /** Email al que se envió el código (el mismo del paso 1). */
  email: string;
  /** Código OTP de 6 dígitos. */
  codigo: string;
};

export const fx_createVerificarCodigoRequest = (
  email: string,
): VerificarCodigoRequest => {
  return {
    email,
    codigo: "",
  };
};
